<template>
  <div class="switch-button" @click="toggle" :class="isOnModifier">
    <div class="switch-button__inner">
      <div class="switch-button__toggle"></div>
    </div>
  </div>
</template>

<script src="./switch-button.js"></script>
<style src="./switch-button.scss" lang="scss"></style>
